import type { QuoteDocument, OptionsDocument } from 'paintscout'
import { expiryEnabled } from '../expiry-enabled/expiry-enabled'

/*
 * Checks if given quote should be treated as expired
 */
export function isExpired(args: { quote: QuoteDocument; options: OptionsDocument; isWorkOrder?: boolean }): boolean {
  const { quote, options, isWorkOrder } = args
  if (quote.is_invoice) {
    return false
  }
  const isExpiryEnabled = expiryEnabled({ quote, options })
  const expiryInterval = quote.options?.customerViewExpiry?.interval

  const isExpired = (() => {
    if (!isExpiryEnabled || ['accepted', 'invoiced'].includes(quote?.status?.value) || isWorkOrder) {
      return false
    }
    return quote.dates?.expiryDate
      ? quote?.dates?.expiryDate < Date.now()
      : quote.dates?.client?.sent + expiryInterval < Date.now()
  })()

  return isExpired
}
